<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    import type { Purchase } from '../../modules/paymentsApi/purchases/purchase.entity'
    import Zinput from '../_common/z/zinput.svelte'
    import Zact from '../_common/z/zact.svelte'
    import Zframe from '../_common/z/zframe.svelte'
    import { ChangePurchaseDueDateInputDto, ChangePurchaseDueDateOutputDto } from '../../modules/paymentsApi/purchases/dto/change-purchase-due-date.dto'
    import { faSave } from '@fortawesome/free-regular-svg-icons'
    import Zgrid from '../_common/z/zgrid.svelte'
    import ZContainer from '../_common/z/z-container.svelte'
    import ZContainerCol from '../_common/z/z-container-col.svelte'
    import dayjs from 'dayjs'
    import Zbutton from '../_common/z/zbutton.svelte'

    // ##############################################################################################################
    const dispatch = createEventDispatcher()

    export let purchaseId: string

    let entity: ChangePurchaseDueDateInputDto = new ChangePurchaseDueDateInputDto()
    entity.simulation = true
    let purchase: Purchase = null

    async function loadPurchase() {
        purchase = await window.api.payments.purchases.getOne(purchaseId)
    }

    onMount(async () => {
        await loadPurchase()
    })

    let step = 1

    let simulation: ChangePurchaseDueDateOutputDto = null
    async function goSimulate() {
        try {
            if (!entity.newDueDay) {
                window.error('Informe o dia do novo vencimento')
                return
            }
            entity.simulation = true
            simulation = await window.api.payments.purchases.changeDueDate(purchase.purchaseId, entity)
            step = 2
        } catch (error) {
            window.error(error.message || error)
        }
    }
    async function goSave() {
        try {
            entity.simulation = false
            simulation = await window.api.payments.purchases.changeDueDate(purchase.purchaseId, entity)
            dispatch('close')
        } catch (error) {
            window.error(error.message || error)
        }
    }

    let options = []
    for (let index = 1; index <= 28; index++) {
        options.push({
            value: index,
            label: index,
        })
    }
</script>

<div class="root">
    <Zact>
        <div class="spacer" />
        {#if window.store.token.permissions.account.users.write}
            {#if step === 1}
                <Zbutton label="Simular" on:click={goSimulate}></Zbutton>
            {:else}
                <Zbutton label="Voltar" color="yellow" on:click={() => (step = 1)}></Zbutton>
                <Zbutton label="Confirmar alteração" color="green" on:click={goSave}></Zbutton>
            {/if}
        {/if}
    </Zact>
    <div class="alert alert-primary text-center m-3">Atenção: Cobranças com vencimento nos próximos 7 dias não serão alteradas.</div>

    <Zframe title="Novo vencimento" class="m-3">
        {#if step === 1}
            <ZContainer>
                <Zinput size={12} label="Pro-rata" type="toggle" bind:value={entity.proRata}></Zinput>
                <Zinput size={12} label="Dia do novo vencimento" type="select" bind:value={entity.newDueDay} {options}></Zinput>
            </ZContainer>
        {:else}
            <div>O próximo vencimento com a nova data será {dayjs(simulation.chargeCreated.dueDate).format('DD/MM/YYYY')}</div>
            <div>O valor da próxima mensalidade será de {simulation.chargeCreated.value.toFixed(2)} referente a {simulation.chargeCreated.days} dias</div>
            <div>As mensalidades seguintes serão de {purchase.purchaseTotalValue.toFixed(2)}</div>
        {/if}
    </Zframe>
</div>
